module.exports = __webpack_public_path__ + "static/media/Surfer.9eaf3de7.jpg";